import * as yup from 'yup';

// Schémas de validation Yup
const individualWithFamilySituationVAlidationSchema = yup.object().shape({
    civility: yup.string().required('La civilité est requise'),
    firstName: yup
        .string()
        .required('Le prénom est requis'),
    lastName: yup
        .string()
        .required('Le nom est requis'),
    familySituation: yup
        .string()
        .required('La situation familiale est requise'),
    maritalRegime: yup
        .string()
        .required('Le régime matrimonial est requis'),
});

export default individualWithFamilySituationVAlidationSchema